export const newConversation = () => {
  if (!window.drift) {
    return
  }
  return window.drift.on('ready', (api) => api.sidebar.open())
}
